import { useState } from 'react';
import styled from 'styled-components';

import { Flex, Space } from '@/components/base';
import Button from '@/components/Button/Button';
import ToggleRadio from '@/components/Common/ToggleRadio';
import { useModalContext } from '@/components/Modal/Modal';
import Heading from '@/components/Typography/Heading';
import { MainText } from '@/components/Typography/NamedTypo';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import service from '@/services';
import useToastStore from '@/stores/pure/ToastStore';
import { modalStyle } from '@/styles/style';

import type { ChanneltalkInfo } from '../types/types';

type Props = {
  channel?: ChanneltalkInfo;
};

const ChannelTalkImportSettingModal = (props: Props) => {
  const { closeModal } = useModalContext();
  const color = useColor();
  const addDefaultToast = useToastStore((state) => state.addDefaultToast);

  const [customerImport, setCustomerImport] = useState(
    !props.channel?.privacy_policy,
  );

  const [titlePolicy, setTitlePolicy] = useState(
    typeof props.channel?.desc_to_title === 'boolean'
      ? !!props.channel.desc_to_title
      : false,
  );

  const onSaveClick = async () => {
    if (!props.channel) return;
    await service.channeltalk.updateChanneltalkImportUserOption(
      props.channel.alias,
      !customerImport,
    ); // customerImport와 privacy params의 값은 반대
    await service.channeltalk.updateChanneltalkTitleOption(
      props.channel.alias,
      !!titlePolicy,
    );
    addDefaultToast('Setting changed', 'success');
    closeModal();
  };

  return (
    <Style d="column">
      <Heading type="h2">Import setting</Heading>
      <Space h="32px" />
      <Flex d="column" g="8px">
        <Heading type="h3">Customer data</Heading>
        <Typo type="body3" color={color.gray600}>
          It includes all the accounts and contacts in Channel Talk
        </Typo>
        <Flex g="12px" a="center">
          <ToggleRadio
            status={customerImport}
            onChange={(state) => setCustomerImport(state)}
          />
          <MainText>Import customer data</MainText>
        </Flex>
      </Flex>
      <Space h="40px" />
      <Flex d="column" g="16px">
        <Heading type="h3">Feedback title</Heading>
        {/* <Text type="body3" color={color.gray6}>
            Use chat description as the feedback title
          </Text> */}
        <Flex g="12px" a="center">
          <ToggleRadio
            status={titlePolicy}
            onChange={(state) => setTitlePolicy(state)}
          />
          <MainText>Use chat description as the feedback title</MainText>
        </Flex>
      </Flex>
      <Space h="40px" />
      <Flex j="flex-end">
        <Button sizeType="m" onClick={onSaveClick}>
          Save change
        </Button>
      </Flex>
    </Style>
  );
};

const Style = styled(Flex)`
  width: 600px;
  padding: 32px;
  ${modalStyle};
`;

export default ChannelTalkImportSettingModal;
